import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button, Alert } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaFileExcel, FaArrowLeft, FaDownload, FaChartBar, FaBox } from "react-icons/fa";
import axios from "axios";
import { downloadExcelReport } from '../../../services/utils/downloadHelper';
import "react-toastify/dist/ReactToastify.css";

const API_URL = process.env.REACT_APP_PYTHON_API_URL || "http://localhost:8003";

const ReporteInsumos = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const selectedProject = JSON.parse(localStorage.getItem("selectedProject"));

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleGenerarReporte = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const url = `${API_URL}/api/reportes/planificacion-insumos/insumos/excel`;
      
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      // Crear blob y descargar
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url_blob = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url_blob;
      link.download = `reporte_insumos_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url_blob);

      toast.success("Reporte descargado exitosamente");
    } catch (error) {
      console.error("Error al generar reporte:", error);
      toast.error(error.response?.data?.detail || "Error al descargar el reporte");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Digital Harmony Styles para Reportes */}
      <style>
        {`
          .dh-reporte-bg {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            min-height: 100vh;
          }
          
          .dh-main-header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 2rem 0;
            margin-bottom: 2rem;
            border-radius: 0 0 30px 30px;
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.2);
          }
          
          .dh-main-title {
            font-size: 2.5rem;
            font-weight: 700;
            margin: 0;
          }
          
          .dh-main-subtitle {
            font-size: 1.1rem;
            opacity: 0.9;
            margin: 0.5rem 0 0 0;
          }
          
          .dh-card {
            border: none;
            border-radius: 20px;
            box-shadow: 0 15px 35px rgba(0,0,0,0.1);
            background: white;
          }
          
          .dh-card-header {
            border-radius: 15px 15px 0 0;
            padding: 1rem 1.5rem;
            border: none;
            font-weight: 700;
          }
          
          .dh-card-header-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
          }
          
          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 10px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.875rem;
            box-shadow: 0 4px 14px rgba(17, 153, 142, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(17, 153, 142, 0.4);
            color: white;
          }
          
          .btn-dh-secondary {
            background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
            border: none;
            color: white;
            border-radius: 10px;
            padding: 8px 16px;
            font-weight: 600;
            font-size: 0.875rem;
            box-shadow: 0 4px 14px rgba(107, 114, 128, 0.3);
            transition: all 0.3s ease;
          }
          
          .btn-dh-secondary:hover {
            background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(107, 114, 128, 0.4);
            color: white;
          }
          
          .dh-form-control {
            border: 2px solid #e5e7eb;
            border-radius: 10px;
            padding: 12px 16px;
            font-size: 1rem;
            transition: all 0.3s ease;
            background: rgba(255, 255, 255, 0.9);
          }
          
          .dh-form-control:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
            background: white;
          }
          
          .dh-form-label {
            color: #374151;
            font-weight: 600;
            font-size: 0.95rem;
            margin-bottom: 8px;
          }
          
          .dh-alert {
            border: none;
            border-radius: 12px;
            padding: 1rem 1.25rem;
            box-shadow: 0 2px 8px rgba(0,0,0,0.08);
          }
          
          .dh-alert-info {
            background: linear-gradient(135deg, rgba(0, 198, 255, 0.1) 0%, rgba(0, 114, 255, 0.1) 100%);
            border-left: 4px solid #00c6ff;
            color: #0056d1;
          }
        `}
      </style>

      <div className="dh-reporte-bg">
        <ToastContainer />

        <Container>
          <Row className="justify-content-center">
            <Col lg={10} xl={8}>
              <Card className="dh-card">
                <Card.Header className="dh-card-header dh-card-header-primary">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                      <FaBox className="me-3" size={20} />
                      <h5 className="mb-0" style={{ fontSize: '0.95rem', fontWeight: 700 }}>Reporte de Insumos</h5>
                    </div>
                    <Button
                      className="btn-dh-secondary"
                      onClick={() => navigate("/reportes")}
                    >
                      <FaArrowLeft className="me-2" />
                      Volver
                    </Button>
                  </div>
                </Card.Header>
                <Card.Body className="p-4">
                  <Form onSubmit={handleGenerarReporte}>
                    <div className="d-flex justify-content-end gap-3 mt-3">
                      <Button
                        type="button"
                        className="btn-dh-secondary"
                        onClick={() => navigate("/reportes")}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="submit"
                        className="btn-dh-primary d-flex align-items-center"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Generando...
                          </>
                        ) : (
                          <>
                            <FaDownload className="me-2" />
                            Descargar Reporte
                          </>
                        )}
                      </Button>
                    </div>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ReporteInsumos;

